import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './SubscriptionCard.css';

const cx = classnames.bind(styles);

function SubscriptionCard({subscriptionData, selectedSubcriptionData, selectSubscription}) {
    const isActive = subscriptionData.plan === selectedSubcriptionData.plan;

    return (
        <div
            className={cx('root', subscriptionData.plan, {active: isActive, popular: subscriptionData.isPopular})}
            onClick={() => selectSubscription(subscriptionData)}
        >
            {subscriptionData.isPopular && (
                <div className={styles.popularBlock}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Most popular
                </div>
            )}
            <div className={styles.wrapper}>
                <div className={styles.checkbox}>
                    <span className={styles.checkmark}/>
                </div>
                <div className={styles.planInformation}>
                    <div className={styles.secondaryWrapper}>
                        <p className={styles.name}>
                            {subscriptionData.name}
                        </p>
                    </div>

                    <div className={styles.priceBlock}>
                        <span className={styles.price}>{subscriptionData.price}</span>
                    </div>
                </div>
            </div>
            <div className={styles.pricePerDayBlock}>
                <span className={styles.value}>${Number.parseFloat(subscriptionData.pricePerDay / 100).toFixed(2)}</span>
                <span className={styles.label}>per day</span>
            </div>
        </div>
    )
};

SubscriptionCard.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubcriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired
};

export {
    SubscriptionCard
};
